var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container px-8 md:py-8 text-center"},[_c('simple-table',{staticClass:"dvs-w-full",attrs:{"prefix":"","data":_vm.rows,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }